(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const Play = window.RB.Play;

  function topFrame(state) {
    return state.tasks.length ? state.tasks[state.tasks.length - 1] : null;
  }

  function currentItem(state) {
    const f = topFrame(state);
    if (!f) return null;
    if (f.direct) return f.direct;
    if (f.chainId !== undefined) return Play.itemById(state, f.chainId) || null;
    return null;
  }

  function stackTop(state, list, names, label, deckName) {
    for (const name of (names || []).slice().reverse()) {
      const idx = list.findIndex(function (iid) {
        return (Core.card(state, iid) || {}).name === name;
      });
      if (idx < 0) throw new Error(label + ": no " + name + " in the " + deckName);
      list.unshift(list.splice(idx, 1)[0]);
    }
  }

  const MANUAL_OPS = {
    draw(state, arg) { Flow.draw(state, arg.player, arg.n || 1); },
    energy(state, arg) { state.players[arg.player].pool.energy = Math.max(0, state.players[arg.player].pool.energy + arg.n); },
    power(state, arg) {
      const pool = state.players[arg.player].pool;
      const d = arg.domain || "any";
      pool.power[d] = Math.max(0, (pool.power[d] || 0) + arg.n);
    },
    points(state, arg) {
      state.players[arg.player].points = Math.max(0, state.players[arg.player].points + arg.n);
      state.needCleanup = true;
    },
    xp(state, arg) { state.players[arg.player].xp = Math.max(0, state.players[arg.player].xp + arg.n); },
    buff(state, arg) {
      const o = state.objs[arg.iid];
      o.buffs = Math.max(0, o.buffs + (arg.n || 1));
      Flow.mightyPass(state);
    },
    damage(state, arg) {
      Flow.dealDamage(state, [{ iid: arg.iid, amt: arg.n || 1, by: arg.player, src: "manual" }]);
    },
    heal(state, arg) { state.objs[arg.iid].damage = []; },
    kill(state, arg) { Flow.killObjs(state, [arg.iid], { via: "manual" }); },
    banish(state, arg) { Flow.toBanish(state, arg.iid); },
    toHand(state, arg) { Flow.toHand(state, arg.iid); },
    trash(state, arg) { Flow.toTrash(state, arg.iid); },
    recycle(state, arg) { Flow.recycleCards(state, [arg.iid]); },
    ready(state, arg) { state.objs[arg.iid].ready = true; },
    exhaust(state, arg) { state.objs[arg.iid].ready = false; },
    stun(state, arg) { state.objs[arg.iid].stunned = !state.objs[arg.iid].stunned; },
    move(state, arg) { Flow.moveUnits(state, [arg.iid], arg.dest, { by: arg.player }); },
    attach(state, arg) { Flow.attach(state, arg.iid, arg.host); },
    detach(state, arg) { Flow.detach(state, arg.iid); },
    might(state, arg) {
      state.objs[arg.iid].grants.push({ k: "might", value: arg.n, dur: arg.dur || "turn" });
      Flow.mightyPass(state);
    },
    keyword(state, arg) {
      state.objs[arg.iid].grants.push({ k: "keyword", name: arg.kw, value: arg.value, dur: arg.dur || "turn" });
    },
    token(state, arg) {
      const def = RB.Scripts.tokenDef(arg.name);
      if (!def) throw new Error("unknown token " + arg.name);
      const o = Core.makeObj(state, {
        token: def, owner: arg.player, controller: arg.player, zone: "board",
        ready: arg.ready !== false,
      });
      o.loc = arg.dest || { t: "base", p: arg.player };
      o.enteredTurn = state.turn.num;
      state.needCleanup = true;
    },
    put(state, arg) {
      const c = RB.Setup.findCard(arg.card);
      if (!c) throw new Error("unknown card " + arg.card);
      const o = Core.makeObj(state, { card: c.id, owner: arg.player, controller: arg.player });
      const zone = arg.zone || "board";
      if (zone === "hand") {
        o.zone = "hand";
        state.players[arg.player].hand.push(o.iid);
      } else if (zone === "trash") {
        o.zone = "trash";
        state.players[arg.player].trash.push(o.iid);
      } else if (zone === "board") {
        o.zone = "board";
        o.ready = arg.ready !== false;
        o.loc = arg.dest || { t: "base", p: arg.player };
        o.enteredTurn = state.turn.num;
        if (arg.buffs) o.buffs = arg.buffs;
        if (o.loc.t === "bf") {
          const bf = state.objs[o.loc.iid];
          if (bf && bf.controller === null) {
            bf.controller = arg.player;
            bf.contestedBy = null;
          } else if (bf && bf.controller !== arg.player && bf.contestedBy === null &&
            Core.isType(state, o.iid, "unit")) {
            bf.contestedBy = arg.player;
          }
        }
        state.needCleanup = true;
      } else if (zone === "facedown") {
        const dest = arg.dest || {};
        const bf = dest.t === "bf" ? state.objs[dest.iid] : null;
        if (!bf) throw new Error("put facedown: dest must be a battlefield");
        if (!Flow.hideSlotFree(state, dest.iid)) throw new Error("put facedown: a card is already hidden there");
        o.zone = "facedown";
        o.hiddenInfo = { turn: 0 };
        Flow.setHidden(state, dest.iid, o.iid);
        if (bf.controller === null) {
          bf.controller = arg.player;
          bf.contestedBy = null;
        }
        state.needCleanup = true;
      } else {
        throw new Error("put: zone must be hand, board, trash, or facedown");
      }
    },
    control(state, arg) {
      const bf = state.objs[arg.bf];
      bf.controller = arg.player === null || arg.player === undefined ? null : arg.player;
      state.needCleanup = true;
    },
    tutor(state, arg) {
      const player = state.players[arg.player];
      const idx = player.mainDeck.indexOf(arg.iid);
      if (idx >= 0) {
        player.mainDeck.splice(idx, 1);
        state.objs[arg.iid].zone = "hand";
        player.hand.push(arg.iid);
      }
    },
    shuffleDeck(state, arg) {
      Kernel.shuffle(state, state.players[arg.player].mainDeck);
    },
    deckTop(state, arg) {
      stackTop(state, state.players[arg.player].mainDeck, arg.top, "deckTop", "main deck");
    },
    runeOrder(state, arg) {
      stackTop(state, state.players[arg.player].runeDeck, arg.top, "runeOrder", "rune deck");
    },
    note(state, arg) { },
  };

  const Actions = {
    validate(state, action) {
      if (state.over && action.type !== "MANUAL") return "game is over";
      const pd = state.pending;
      const t = action.type;
      if (t === "MANUAL" || t === "CONCEDE") return null;
      if (!pd) return "engine is not waiting for input";

      if (action.player !== pd.player) return "it is player " + (pd.player + 1) + "'s decision";

      switch (pd.kind) {
        case "act":
          if (["PLAY_CARD", "STANDARD_MOVE", "MOVE_GROUP", "HIDE", "ACTIVATE", "END_TURN"].indexOf(t) < 0) return "not available now";
          return null;
        case "focus":
        case "respond":
          if (["PLAY_CARD", "ACTIVATE", "PASS"].indexOf(t) < 0) return "not available now";
          return null;
        case "choose":
          if (t === "CANCEL" && pd.cancellable) return null;
          return t === "CHOOSE" ? null : "a choice is required";
        case "pay":
          if (t === "ACTIVATE" && action.mode) return null;
          return t === "PAY" || t === "CANCEL" ? null : "payment is required";
        case "assign":
          return t === "ASSIGN" ? null : "damage assignment is required";
        case "mulligan":
          return t === "MULLIGAN" ? null : "mulligan decision required";
        case "manual":
          return t === "CONTINUE" ? null : "press continue when done";
        case "moveGroup":
          if (["CHOOSE", "CONTINUE"].indexOf(t) < 0) return "pick another unit, or continue";
          return null;
      }
      return null;
    },

    apply(state, action) {
      const err = Actions.validate(state, action);
      if (err) throw new Error("illegal action: " + err + " (" + action.type + ")");
      const pd = state.pending;
      const h = Actions.handlers[action.type];
      if (!h) throw new Error("unknown action " + action.type);
      h(state, action, pd);
      if (state.pending && ["act", "focus", "respond"].indexOf(state.pending.kind) >= 0) {
        state.pending = null;
      }
    },

    handlers: {
      MULLIGAN(state, a, pd) {
        const p = pd.player;
        const player = state.players[p];
        const cards = (a.cards || []).slice(0, 2);
        for (const iid of cards) {
          const idx = player.hand.indexOf(iid);
          if (idx < 0) throw new Error("mulligan: card not in hand");
        }
        for (const iid of cards) {
          const idx = player.hand.indexOf(iid);
          player.hand.splice(idx, 1);
        }
        for (let i = 0; i < cards.length; i++) RB.Setup.drawRaw(state, p);
        if (cards.length) Flow.recycleCards(state, cards);
        Core.log(state, player.name + " mulligans " + cards.length + " card" + (cards.length === 1 ? "" : "s") + ".",
          { k: "draw", p: p });
        const f = topFrame(state);
        f.i += 1;
        state.pending = null;
      },

      CHOOSE(state, a, pd) {
        if (pd.kind === "moveGroup") {
          const frame = topFrame(state);
          if (!frame || frame.k !== "moveGroup") throw new Error("no group move is being assembled");
          const iid = a.picks && a.picks.length === 1 ? a.picks[0] : null;
          if (!iid || pd.cands.indexOf(iid) < 0) throw new Error("that unit cannot join this move");
          frame.picked = Flow.moveGroupOrder(state, pd.player, frame.picked.concat([iid]));
          state.pending = null;
          return;
        }
        state.pending = null;
        if (pd.tag === "pickStaged") {
          Flow.initiateAt(state, a.picks[0]);
          return;
        }
        if (pd.tag === "orderTriggers") {
          const idx = a.optionIdx;
          if (idx === undefined || idx < 0 || idx >= pd.options.length) throw new Error("bad option");
          const mine = state.triggerQueue.filter(function (t) { return t.controller === pd.player; });
          const qIdx = state.triggerQueue.indexOf(mine[idx]);
          if (qIdx < 0) throw new Error("trigger no longer queued");
          Core.log(state, state.players[pd.player].name + " puts \"" + mine[idx].label + "\" on the chain.",
            { k: "trigger", p: pd.player, iids: [mine[idx].source].filter(Boolean) });
          Flow.placeQueuedTrigger(state, qIdx);
          return;
        }
        const f = topFrame(state);
        const item = currentItem(state);
        if (pd.tag === "name" && a.name !== undefined) {
          const universe = RB.FX.nameUniverse(pd.nameKind || "tag", pd.nameType || null);
          if (universe.indexOf(a.name) < 0) throw new Error("not a nameable " + (pd.nameKind === "card" ? "card" : "tag"));
          if (pd.varKey && item) item.vars[pd.varKey] = a.name;
          return;
        }
        if (pd.options) {
          const idx = a.optionIdx;
          if (idx === undefined || idx < 0 || idx >= pd.options.length) throw new Error("bad option");
          if (pd.frameKey && f) {
            f.answers[pd.frameKey] = pd.tag === "may" ? idx === 0 : idx;
          } else if (pd.varKey && item) {
            item.vars[pd.varKey] = idx;
          }
          return;
        }
        const picks = a.picks || [];
        if (picks.length < (pd.min || 0)) throw new Error("too few picks");
        if (picks.length > (pd.max || 1)) throw new Error("too many picks");
        for (const pick of picks) {
          const ok = pd.cands.some(function (c) {
            if (pd.locChoices) return JSON.stringify(c) === JSON.stringify(pick);
            return c === pick;
          });
          if (!ok) throw new Error("pick not among candidates");
        }
        if (!Play.cohereOk(state, pd, picks)) throw new Error("picks must all be at the same location");
        if (pd.frameKey && f) {
          f.answers[pd.frameKey] = pd.locChoices || pd.max === 1 ? picks[0] : picks;
          return;
        }
        if (pd.varKey && item) {
          item.vars[pd.varKey] = pd.locChoices ? picks[0] : picks;
          return;
        }
        if (pd.bind && item) {
          item.targets[pd.bind] = picks;
          const facts = state.turnFacts.players[item.controller];
          for (const t of picks) {
            const to = state.objs[t];
            if (!to || to.zone !== "board") continue;
            facts.chose += 1;
            if (to.controller !== item.controller) facts.choseEnemy += 1;
            if (to.controller !== item.controller && Core.isType(state, t, "unit")) facts.choseEnemyUnit += 1;
          }
          RB.FX.emit(state, { type: "targeted", by: item.controller, targets: picks, label: item.label });
          return;
        }
        throw new Error("choice had nowhere to go");
      },

      PAY(state, a, pd) {
        const p = pd.player;
        const ctx = pd.payCtx || {};
        let acts = a.activations;
        if (a.auto) {
          acts = Play.autoPayPlan(state, p, pd.cost, ctx);
          if (!acts) throw new Error("cannot afford this cost");
        }
        const before = Kernel.deepClone(state.players[p].pool);
        const beforeReady = {};
        for (const act of acts || []) {
          const e = Play.runActivation(state, p, act);
          if (e) throw new Error("payment activation failed: " + e);
        }
        if (!Play.poolCovers(state.players[p].pool, pd.cost, ctx)) {
          throw new Error("pool does not cover the cost after activations");
        }
        Play.spendCost(state, p, pd.cost, ctx);
        const counts = { exhaustRune: 0, recycleRune: 0, legend: 0 };
        for (const act of acts || []) counts[act.mode] = (counts[act.mode] || 0) + 1;
        const bits = [];
        if (pd.cost.energy) bits.push(pd.cost.energy + " energy");
        const powerN = (pd.cost.pips || []).length + (pd.cost.anyPower || 0);
        if (powerN) bits.push(powerN + " power");
        const how = [];
        if (counts.exhaustRune) how.push("exhausted " + counts.exhaustRune + " rune" + (counts.exhaustRune > 1 ? "s" : ""));
        if (counts.recycleRune) how.push("recycled " + counts.recycleRune + " rune" + (counts.recycleRune > 1 ? "s" : ""));
        if (counts.legend) how.push("used the legend");
        Core.log(state, state.players[p].name + " pays " + (bits.join(" + ") || "nothing") +
          (how.length ? " (" + how.join(", ") + ")" : " from the pool") + ".", { k: "resource", p: p });
        const f = topFrame(state);
        if (f && f.answers) f.answers.paid = true;
        if (pd.varKey) {
          const payItem = currentItem(state);
          if (payItem) payItem.vars[pd.varKey] = true;
        }
        state.pending = null;
      },

      CANCEL(state, a, pd) {
        if (!pd.cancellable) throw new Error("cannot cancel");
        const item = currentItem(state);
        state.pending = null;
        if (pd.varKey) {
          if (item) item.vars[pd.varKey + "Cancel"] = true;
          return;
        }
        if (item && (item.kind === "spell" || item.kind === "permanent")) {
          Play.cancelPlay(state, item);
          state.tasks.pop();
        } else if (item && item.kind === "ability") {
          if (item.undo && item.source && state.objs[item.source]) {
            const src = state.objs[item.source];
            if (item.undo.exhausted) src.ready = true;
            if (item.undo.onceKey) delete src.flags[item.undo.onceKey];
          }
          Play.removeChainItem(state, item.id);
          state.tasks.pop();
        }
      },

      ASSIGN(state, a, pd) {
        const dist = a.dist || {};
        let sum = 0;
        for (const iid in dist) {
          if (pd.targets.indexOf(iid) < 0) throw new Error("assign: not a combat target");
          if (dist[iid] < 0 || Math.floor(dist[iid]) !== dist[iid]) throw new Error("assign: bad amount");
          sum += dist[iid];
        }
        const minLethal = function (iid) { return Core.lethalLeft(state, iid); };
        let capacity = 0;
        for (const iid of pd.targets) capacity += minLethal(iid);
        const expected = Math.min(pd.total, capacity);
        if (sum < expected) throw new Error("assign all damage (need " + expected + ", got " + sum + ")");
        if (state.showdown) {
          state.showdown.excess[pd.player] = Math.max(0, sum - capacity);
        }
        if (sum > pd.total) throw new Error("assigned more than available");
        const allLethal = pd.targets.every(function (t) { return (dist[t] || 0) >= minLethal(t); });
        const partials = pd.targets.filter(function (t) {
          return (dist[t] || 0) > 0 && (dist[t] || 0) < minLethal(t);
        });
        for (const t of pd.targets) {
          if ((dist[t] || 0) > minLethal(t) && !allLethal) {
            throw new Error("cannot over-assign " + Core.name(state, t) + " while other units lack lethal damage");
          }
        }
        if (partials.length > 1) throw new Error("must fill lethal damage on one unit before starting another");
        if (partials.length === 1 && sum < pd.total) {
          throw new Error("a partially-assigned unit is only legal when all damage is used");
        }
        const ignoreTank = !!(state.showdown && Core.ignoresTankAt(state, pd.player, state.showdown.bf));
        const tank = ignoreTank ? [] : pd.targets.filter(function (iid) { return Core.hasKw(state, iid, "tank"); });
        const back = pd.targets.filter(function (iid) { return Core.hasKw(state, iid, "backline"); });
        const mid = pd.targets.filter(function (iid) { return tank.indexOf(iid) < 0 && back.indexOf(iid) < 0; });
        const assignedIn = function (group) {
          return group.some(function (iid) { return (dist[iid] || 0) > 0; });
        };
        const groupSatisfied = function (group) {
          return group.every(function (iid) { return (dist[iid] || 0) >= minLethal(iid); });
        };
        if ((assignedIn(mid) || assignedIn(back)) && !groupSatisfied(tank)) {
          throw new Error("Tank units must be assigned lethal damage first");
        }
        if (assignedIn(back) && !groupSatisfied(mid)) {
          throw new Error("Backline units must be assigned damage last");
        }
        state.showdown[pd.slot] = dist;
        state.showdown.stage = pd.slot === "atkAssign" ? "damageDef" : "dealDamage";
        state.pending = null;
      },

      PLAY_CARD(state, a, pd) {
        const p = pd.player;
        const iid = a.iid;
        const why = Play.playBlocked(state, p, iid, pd.kind);
        if (why) throw new Error(why);
        const origin = Play.playOrigin(state, p, iid);
        if (origin.fromZone === "champion") {
          const ci = state.players[p].champion.indexOf(iid);
          state.players[p].champion.splice(ci, 1);
        }
        Play.beginPlay(state, p, iid, { fromZone: origin.fromZone, hiddenBf: origin.hiddenBf, timing: pd.kind });
        state.pending = null;
      },

      STANDARD_MOVE(state, a, pd) {
        const p = pd.player;
        const units = a.units || [];
        const dest = a.dest;
        const why = Play.moveBlocked(state, p, units, dest);
        if (why) throw new Error(why);
        Flow.performStandardMove(state, p, units, dest);
        state.pending = null;
      },

      MOVE_GROUP(state, a, pd) {
        const p = pd.player;
        const cands = Flow.moveGroupCands(state, p, a.dest, []);
        if (cands.length < 2) throw new Error("no group move is available there");
        state.tasks.push({ k: "moveGroup", player: p, dest: a.dest, picked: [], go: false });
        state.pending = null;
      },

      HIDE(state, a, pd) {
        const p = pd.player;
        const iid = a.iid;
        const o = state.objs[iid];
        const why = Play.hideBlocked(state, p, iid, a.bf, a.costIdx);
        if (why) throw new Error(why);
        const bf = state.objs[a.bf];

        const costs = Play.hideCosts(state, p);
        const wanted = a.costIdx === undefined ? costs : [costs[a.costIdx]];
        let cost = null;
        for (const c of wanted) {
          if (!c) continue;
          if ((!c.energy && !c.anyPower) || Play.poolCovers(state.players[p].pool, c)) { cost = c; break; }
          const plan = Play.autoPayPlan(state, p, c);
          if (!plan) continue;
          for (const act of plan) {
            const e = Play.runActivation(state, p, act);
            if (e) throw new Error(e);
          }
          cost = c;
          break;
        }
        if (!cost) throw new Error("cannot pay the Hide cost");
        Play.spendCost(state, p, cost);
        const hi = state.players[p].hand.indexOf(iid);
        state.players[p].hand.splice(hi, 1);
        o.zone = "facedown";
        o.hiddenInfo = { turn: state.turn.num };
        Flow.setHidden(state, a.bf, iid);
        Core.log(state, state.players[p].name + " hides a card at " + Core.name(state, a.bf) + ".",
          { k: "play", p: p, iids: [a.bf] });
        RB.FX.emit(state, { type: "hidden", iid: iid, player: p, bf: a.bf });
        state.pending = null;
        state.needCleanup = true;
      },

      ACTIVATE(state, a, pd) {
        const p = pd.player;
        if (a.mode) {
          const e = Play.runActivation(state, p, { iid: a.iid, mode: a.mode });
          if (e) throw new Error(e);
          Core.log(state, state.players[p].name + " adds resources (" + a.mode + ").",
            { k: "resource", p: p, iids: [a.iid] });
          return;
        }
        const iid = a.iid;
        const o = state.objs[iid];
        const ai = a.ability || 0;
        const why = Play.abilityBlocked(state, p, iid, ai, pd.kind);
        if (why) throw new Error(why);
        const ab = RB.Scripts.abilitiesOf(state, iid)[ai];
        const cost = Play.abilityCost(state, iid, ab);

        const sourceCard = Core.card(state, iid);
        const abilityLabel = Core.name(state, iid) + " ability";
        const undo = { exhausted: false, onceKey: null };
        if (ab.exhausts) { o.ready = false; undo.exhausted = true; }
        if (ab.spendBuffSelf) Flow.spendBuff(state, iid, p);
        if (ab.disempowerSelf) {
          o.empowerCount = Math.max(0, (o.empowerCount || 1) - 1);
          o.empowered = o.empowerCount > 0;
        }
        if (ab.killSelf) Flow.killObjs(state, [iid], { via: "cost" });
        let banishedWith = null;
        if (ab.banishSelf) {
          banishedWith = (o.flags.banishedWith || []).slice();
          Core.log(state, Core.name(state, iid) + " is banished (cost).", { k: "zone", p: p, iids: [iid] });
          Flow.toBanish(state, iid);
        }
        if (ab.oncePerTurn) {
          undo.onceKey = "used" + (a.ability || 0);
          o.flags[undo.onceKey] = state.turn.num;
        }
        state.turnFacts.players[p].abilitiesUsed += 1;
        if (Core.isType(state, iid, "gear")) state.turnFacts.players[p].gearAbilitiesUsed += 1;
        const item = Flow.addChainItem(state, {
          kind: "ability",
          controller: p,
          source: iid,
          cardId: sourceCard ? sourceCard.id : null,
          label: abilityLabel,
          abilityText: ab.label || null,
          program: ab.program,
          targetSpecs: ab.targets || [],
          cost: cost,
          costMeta: (ab.costDiscard || ab.costKillFriendly || ab.costRecycleTrash || ab.costXp)
            ? { costDiscard: ab.costDiscard || 0, costDiscardType: ab.costDiscardType || null, costKillFriendly: !!ab.costKillFriendly,
                costRecycleTrash: ab.costRecycleTrash || 0, costXp: ab.costXp || 0 }
            : null,
          energyLessByTargetMight: ab.energyLessByTargetMight || null,
          isAdd: !!ab.isAdd,
          ctx: { bf: o.loc && o.loc.t === "bf" ? o.loc.iid : null, banishedWith: banishedWith },
          openerKind: ab.isAdd ? "add" : "play",
          undo: undo,
        });
        state.pending = null;
      },

      PASS(state, a, pd) {
        state.pending = null;
        if (pd.kind === "respond") {
          state.passCount += 1;
          state.priority = Core.otherPlayer(pd.player);
          return;
        }
        if (pd.kind === "focus") {
          state.showdown.passes += 1;
          state.showdown.focus = Core.otherPlayer(pd.player);
          return;
        }
      },

      END_TURN(state, a, pd) {
        state.turn.phase = "ending";
        state.turn.step = 0;
        state.priority = null;
        state.pending = null;
        Core.log(state, state.players[pd.player].name + " ends the turn.", { k: "phase", p: pd.player });
      },

      CONTINUE(state, a, pd) {
        if (pd.kind === "moveGroup") {
          const frame = topFrame(state);
          if (!frame || frame.k !== "moveGroup") throw new Error("no group move is being assembled");
          if (!pd.canGo) throw new Error("pick at least two units before moving");
          frame.go = true;
          state.pending = null;
          return;
        }
        const item = currentItem(state);
        if (item) item.vars.manualDone = true;
        state.pending = null;
      },

      CONCEDE(state, a) {
        const p = a.player;
        state.over = { winner: Core.otherPlayer(p), conceded: p };
        Core.log(state, state.players[p].name + " concedes.", { k: "game", p: p });
        state.pending = null;
      },

      MANUAL(state, a) {
        Actions.manual(state, a);
      },
    },

    manual(state, a) {
      const fn = MANUAL_OPS[a.op];
      if (!fn) throw new Error("unknown manual op " + a.op);
      const arg = a.args || {};
      fn(state, arg);
      Core.log(state, "[manual] " + a.op + " " + JSON.stringify(arg), {
        k: "manual", p: arg.player, iids: [arg.iid, arg.host, arg.bf].filter(Boolean),
      });
    },
  };

  const Engine = {
    initialState(setup) {
      return RB.Setup.initialState(setup);
    },
    advance(state) {
      Flow.advance(state);
    },
    applyAction(state, action) {
      Actions.apply(state, action);
    },
  };

  window.RB.Actions = Actions;
  window.Engine = Engine;
})();
